import { getBaseRole, hasBaseRole } from '@/helpers/customRoles';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import s from './index.module.css'
import { GetIco } from '@/utils/icons'
import { Link, NavLink, useLocation } from 'react-router-dom'
import cn from 'classnames'
import { connect, useDispatch, useSelector } from 'react-redux'
import { ButtonEditNew } from '@UI/Button'
import { selectProfile } from '@store/profile.reducer'
import { formateName } from '@helpers/formateName'
import { getAvatar } from '@helpers/getAvatar'
import { selectorOwnBacklogCount } from '@store/children/children.reducer'
import { selectorTotalCountUHW } from '@store/seminarian/seminarian.reducer'
import { fetchMenu } from '@store/menu.reducer'
import classNames from 'classnames'
import BalanceBlock from '@UI/BalanceBlock'
import QModals from '@pages/Main/Requests/Qmodals'
import LicenseAndPaymentButton from './components/LicenseAndPaymentButton/LicenseAndPaymentButton'
import PlatformSupportLauncher from '@common/PlatformSupport/PlatformSupportLauncher'
import { useIsMinimizedMenu } from '@/hooks/useIsMinimizedMenu'
import { actionExpandedMenu, actionMinimizedMenu } from '@store/menu.reducer'
import { useScreenWidth } from '@/hooks/useScreenWidth'
import { Popover, Tooltip } from 'antd'
import backgraundColorList from './backgraundColorList'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import { selectSelectedLanguageId } from '@store/languageSlice'
import { getCorrectFilePath } from '@/helpers/new/getCorrectFilePath'
import { getSidebarFeatureByPath } from './sidebarFeatureRegistry'
import {
  getMenuNoticeCountTooltip,
  shouldShowMenuNoticeCount,
} from './menuNoticeTooltips'
import { CheckOutlined, DragOutlined, SettingOutlined } from '@ant-design/icons'
import {
  DndContext,
  KeyboardSensor,
  PointerSensor,
  closestCenter,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  SortableContext,
  arrayMove,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import {
  getMenuGroupKey,
} from '@/helpers/userInterfaceOrder'
import { menuApi } from '@/api'
import {
  getMenuCustomizationKey,
  getMenuIconStyle,
  parsePlatformMenuIcons,
  PLATFORM_MENU_ICONS_SETTING_KEY,
} from '@/helpers/menuIconCustomization'
import {
  closeReportsNavigation,
  isReportsNavigationUrl,
  openReportsNavigation,
  REPORTS_NAVIGATION_HOVER_EVENT,
} from '@/helpers/reportsNavigation'
import { useRoleActive } from '@/hooks/useRoleActive'
import { useGetGroupName } from '@pages/Admin/PlatformSettings2/AddSettingsEmployeesPersonAccount/hooks/useGetGroupName'

const MENU_ITEM_DRAG_PREFIX = 'menu-item-'
const getMenuItemDragKey = (item) => `${MENU_ITEM_DRAG_PREFIX}${item.id}`
const USER_STUDENTS_DEFAULT_ROLES = [
  'admin',
  'junior-admin',
  'seminarian',
  'senior-seminarian',
  'personal-manager',
  'sales-manager',
]
const MANAGE_CLASSES_ROLES = ['admin', 'junior-admin', 'franchise-manager']

const getMenuItemUrl = (item, userRole) => {
  if (
    item?.url === '/users/colleges' &&
    USER_STUDENTS_DEFAULT_ROLES.includes(getBaseRole(userRole))
  ) {
    return '/users/students'
  }

  return item?.url
}

const PLATFORM_TRAINING_TARGET_URLS = [
  '/users/students',
  '/users/colleges',
  '/manage',
]

const isPlatformTrainingTarget = (item, userRole) => (
  PLATFORM_TRAINING_TARGET_URLS.includes(getMenuItemUrl(item, userRole)?.split('?')?.[0])
  || (
    item?.title?.toLocaleLowerCase?.('ru-RU')?.includes('ученик')
    && item?.title?.toLocaleLowerCase?.('ru-RU')?.includes('коллег')
  )
)

const getMenuOrderKey = (type, id) => `${type}:${id}`

const getMenuOrderId = (value) => {
  const id = Number(value)
  return Number.isInteger(id) && id > 0 ? id : null
}

const getMenuOrderPosition = (item) => {
  if (item?.position === null || item?.position === undefined) return null
  const position = Number(item.position)
  return Number.isInteger(position) && position >= 0 ? position : null
}

const getMenuOrderParentId = (item) => {
  if (item?.parent_folder_id === null || item?.parent_folder_id === undefined) return null
  return getMenuOrderId(item.parent_folder_id) ?? undefined
}

const sortMenuEntries = (entries, getPosition) => [...entries].sort((first, second) => {
  const firstPosition = getPosition(first)
  const secondPosition = getPosition(second)

  if (firstPosition === null && secondPosition === null) return first.defaultPosition - second.defaultPosition
  if (firstPosition === null) return 1
  if (secondPosition === null) return -1
  if (firstPosition !== secondPosition) return firstPosition - secondPosition

  return first.defaultPosition - second.defaultPosition
})

const applyUserMenuOrder = (menu, savedOrder) => {
  const visibleMenu = menu.filter((group) => !group.folder || Number(group.folder.is_active) !== 0)
  const folders = new Map()
  const items = []
  const savedItems = new Map()
  const order = Array.isArray(savedOrder) ? savedOrder : []

  order.forEach((item) => {
    const id = getMenuOrderId(item?.element_id)
    if (!id || !['item', 'folder'].includes(item?.element_type)) return
    savedItems.set(getMenuOrderKey(item.element_type, id), item)
  })

  visibleMenu.forEach((group, groupIndex) => {
    const folderId = getMenuOrderId(group.folder?.id)
    if (folderId) {
      folders.set(folderId, {
        folder: group.folder,
        defaultPosition: groupIndex,
        items: [],
      })
    }

    ;(group.items ?? []).forEach((item, itemIndex) => {
      if (!item || typeof item.url !== 'string') return

      const itemId = getMenuOrderId(item.id)
      if (!itemId) return

      items.push({
        item,
        id: itemId,
        defaultFolderId: folderId,
        defaultPosition: groupIndex + itemIndex / 1000,
      })
    })
  })

  const rootItems = []
  items.forEach((entry) => {
    const savedItem = savedItems.get(getMenuOrderKey('item', entry.id))
    const savedParentId = getMenuOrderParentId(savedItem)
    const folderId = savedItem && (savedParentId === null || folders.has(savedParentId))
      ? savedParentId
      : entry.defaultFolderId
    const itemEntry = { ...entry, savedItem, folderId }

    if (folderId === null) {
      rootItems.push(itemEntry)
    } else if (folders.has(folderId)) {
      folders.get(folderId).items.push(itemEntry)
    }
  })

  const topLevelEntries = []
  folders.forEach((group, folderId) => {
    if (!group.items.length) return

    const savedFolder = savedItems.get(getMenuOrderKey('folder', folderId))
    group.items = sortMenuEntries(group.items, (item) => (
      item.folderId === getMenuOrderParentId(item.savedItem) ? getMenuOrderPosition(item.savedItem) : null
    )).map((item) => item.item)
    topLevelEntries.push({
      ...group,
      type: 'folder',
      id: folderId,
      savedItem: getMenuOrderParentId(savedFolder) === null ? savedFolder : null,
    })
  })

  rootItems.forEach((item) => {
    topLevelEntries.push({
      folder: null,
      items: [item.item],
      type: 'item',
      id: item.id,
      savedItem: item.folderId === getMenuOrderParentId(item.savedItem) ? item.savedItem : null,
      defaultPosition: item.defaultPosition,
    })
  })

  return sortMenuEntries(topLevelEntries, (item) => getMenuOrderPosition(item.savedItem))
    .map(({ folder, items }) => ({ folder, items }))
}

const sidebarCollisionDetection = (args) => {
  const isDraggingMenuItem = String(args.active.id).startsWith(MENU_ITEM_DRAG_PREFIX)
  const activeContainerId = args.active.data.current?.sortable?.containerId
  const droppableContainers = args.droppableContainers.filter((container) => {
    const isMenuItem = String(container.id).startsWith(MENU_ITEM_DRAG_PREFIX)

    if (!isDraggingMenuItem) return !isMenuItem
    if (!isMenuItem) return false

    return !activeContainerId || container.data.current?.sortable?.containerId === activeContainerId
  })

  return closestCenter({ ...args, droppableContainers })
}

const SidebarContent = ({
  isMinimizedMenu,
  profile,
}) => {
  return (
    <>
      <div className={classNames(s.userInfo, {[s.center]: isMinimizedMenu})}>
        <div className={s.logoWrapper}>
          {
            !isMinimizedMenu && <img
              className={s.avatar}
              src={getAvatar(profile)}
              alt={profile?.name}
            />
          }
          {
            isMinimizedMenu && <Link to={['children', 'parent'].includes(getBaseRole(profile?.role)) ? '/profile' : '/personal'}>
              <img
                className={s.avatar}
                src={getAvatar(profile)}
                alt={profile?.name}
              />
            </Link>
          }
        </div>
        {
          !isMinimizedMenu && (
            <div className={s.userData}>
              <div className={s.fio}>
                {formateName(profile?.name, 'F I')}
                {showUserCustomId(profile)}
              </div>
              <div className={s.mail} title={profile?.email}>{profile?.email}</div>
              <Link
                to={['children', 'parent'].includes(getBaseRole(profile?.role)) ? '/profile' : '/personal'}
                className={s.linkEdit}
              >
                <ButtonEditNew className={s.btnEdit} />
              </Link>
            </div>
          )
        }
      </div>

      <NavigationApp isMinimizedMenuOverride={isMinimizedMenu} />
    </>
  )
}

const Sidebar = () => {
  const { pathname } = useLocation()
  const isMinimizedMenu = useIsMinimizedMenu()
  const isMobile = useScreenWidth(991)
  const isMinimized = useSelector((state) => state.menu.isMinimized)
  const dispatch = useDispatch()
  const [isHovered, setIsHovered] = useState(false)
  const sidebarLeaveTimeoutRef = useRef(null)
  const sidebarHoveredRef = useRef(false)
  const reportsNavigationHoveredRef = useRef(false)

  const cancelSidebarLeave = useCallback(() => {
    if (sidebarLeaveTimeoutRef.current === null) return
    clearTimeout(sidebarLeaveTimeoutRef.current)
    sidebarLeaveTimeoutRef.current = null
  }, [])

  const scheduleSidebarLeave = useCallback(() => {
    cancelSidebarLeave()
    sidebarLeaveTimeoutRef.current = setTimeout(() => {
      if (!reportsNavigationHoveredRef.current) setIsHovered(false)
      sidebarLeaveTimeoutRef.current = null
    }, 220)
  }, [cancelSidebarLeave])

  useEffect(() => {
    const handleReportsNavigationHover = (event) => {
      reportsNavigationHoveredRef.current = Boolean(event.detail?.isHovered)
      if (reportsNavigationHoveredRef.current) {
        cancelSidebarLeave()
        if (!isMobile && isMinimizedMenu) setIsHovered(true)
      } else if (!isMobile && !sidebarHoveredRef.current) {
        scheduleSidebarLeave()
      }
    }

    window.addEventListener(
      REPORTS_NAVIGATION_HOVER_EVENT,
      handleReportsNavigationHover,
    )
    return () => {
      window.removeEventListener(
        REPORTS_NAVIGATION_HOVER_EVENT,
        handleReportsNavigationHover,
      )
      cancelSidebarLeave()
    }
  }, [cancelSidebarLeave, isMobile, isMinimizedMenu, scheduleSidebarLeave])
  const toggleMenu = () => {
    if (isMinimized) {
      dispatch(actionExpandedMenu())
    } else {
      setIsHovered(false)
      dispatch(actionMinimizedMenu())
    }
  }
  const profile = useSelector(selectProfile)
  const isShow = useSelector((state) => state.page.showSidebar)
  const [logo, setLogo] = useState('/logo.svg')
  const [show, setShow] = useState(false)
  const [type, setType] = useState(false)
  const handleClick = () => {
    if (['admin', 'junior-admin'].includes(getBaseRole(profile?.role))) return
    setShow(true)
    setType('ProblemSite')
  }
  const balance = profile?.balance !== undefined ? profile.balance : 0
  const settings = useSelector((store) => store.settings)

  useEffect(() => {
    if (settings?.mainLogo) {
      setLogo(getCorrectFilePath(settings?.mainLogo))
    }
  }, [settings])

  const hasAnyAdmin = ['admin', 'junior-admin'].some((item) =>
    hasBaseRole(profile?.roles, item),
  )

  const hasRoleAdmin = hasBaseRole(profile?.roles, 'admin')

  const isTemporarilyExpanded = !isMobile && isMinimizedMenu && isHovered
  const isVisuallyMinimized = isMinimizedMenu && !isTemporarilyExpanded
  const SidebarFeatureComponent = getSidebarFeatureByPath(pathname)
  const shouldUseSidebarFeature = SidebarFeatureComponent && !isVisuallyMinimized
  const toggleMenuTitle = isTemporarilyExpanded
    ? 'Закрепить меню'
    : isMinimized
      ? 'Развернуть меню'
      : 'Свернуть меню'

  return (
    <>
      <aside
        className={cn(
          { [s.show]: isShow },
          'app-sidebar',
          { 'app-sidebar-visually-minimized': isVisuallyMinimized },
          s.barWrapper,
          { [s.barWrapperMinimized]: isVisuallyMinimized },
        )}
        onMouseEnter={() => {
          sidebarHoveredRef.current = true
          cancelSidebarLeave()
          if (!isMobile && isMinimizedMenu) setIsHovered(true)
        }}
        onMouseLeave={() => {
          sidebarHoveredRef.current = false
          if (!isMobile) scheduleSidebarLeave()
        }}
      >

        {shouldUseSidebarFeature ? (
          <SidebarFeatureComponent
            isMobile={isMobile}
            isMinimizedMenu={isVisuallyMinimized}
            desktopToggleButton={
              !isMobile && (
                <button
                  type="button"
                  className={s.toggleMenu}
                  onClick={toggleMenu}
                  title={toggleMenuTitle}
                  aria-label={toggleMenuTitle}
                >
                  <span
                    className={classNames(s.toggleMenuIcon, {
                      [s.toggleMenuIconOpen]: isMinimized,
                    })}
                  />
                </button>
              )
            }
            defaultContent={
              <SidebarContent
                isMinimizedMenu={isVisuallyMinimized}
                profile={profile}
              />
            }
          />
        ) : (
          <div className={s.contentWrapper}>
            {!isMobile && (
              <button
                type="button"
                className={s.toggleMenu}
                onClick={toggleMenu}
                title={toggleMenuTitle}
                aria-label={toggleMenuTitle}
              >
                <span
                  className={classNames(s.toggleMenuIcon, {
                    [s.toggleMenuIconOpen]: isMinimized,
                  })}
                />
              </button>
            )}
            <SidebarContent
              isMinimizedMenu={isVisuallyMinimized}
              profile={profile}
            />
          </div>
        )}

        <div className={s.sidebarFooter}>
          {!isVisuallyMinimized && <BalanceBlock />}
          {!isVisuallyMinimized && <BalanceBlock type="additionalActivities" />}
          <PlatformSupportLauncher
            sidebar
            className={classNames(s.support, s.navLink)}
            isMinimizedMenu={isVisuallyMinimized}
          />
          {hasRoleAdmin && (
            <LicenseAndPaymentButton
              className={classNames(s.support, s.navLink)}
              isMinimizedMenu={isVisuallyMinimized}
            />
          )}
          {/*{*/}
          {/*  isShowSupportButton() && <SupportHelper isDisabled={!hasAnyAdmin}>*/}
          {/*    <Tooltip title={isMinimizedMenu ? 'Поддержка' : ''} placement='right'>*/}
          {/*      <div onClick={handleClick} */}
          {/*        title={!isMinimizedMenu ? 'Поддержка' : ''} */}
          {/*        className={classNames(s.support, {[s.center]: isMinimizedMenu}, s.navLink)}>*/}
          {/*        <SupportIcon />*/}
          {/*        {!isMinimizedMenu ? 'Поддержка' : ''}*/}
          {/*      </div>*/}
          {/*    </Tooltip>*/}
          {/*  </SupportHelper>*/}
          {/*}*/}
        </div>
      </aside>
      <QModals type={type} active={show} setActive={setShow} />
    </>
  )
}

export default Sidebar

const SidebarMarqueeText = ({ title }) => {
  const wrapperRef = useRef(null)
  const innerRef = useRef(null)
  const [shift, setShift] = useState(0)

  useEffect(() => {
    const wrapper = wrapperRef.current
    const inner = innerRef.current

    if (!wrapper || !inner) return undefined

    const updateShift = () => {
      const nextShift = inner.scrollWidth - wrapper.clientWidth
      setShift(nextShift > 2 ? nextShift : 0)
    }

    updateShift()

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', updateShift)
      return () => window.removeEventListener('resize', updateShift)
    }

    const resizeObserver = new ResizeObserver(updateShift)
    resizeObserver.observe(wrapper)
    resizeObserver.observe(inner)

    return () => resizeObserver.disconnect()
  }, [title])

  return (
    <span className={s.navText} ref={wrapperRef}>
      <span
        ref={innerRef}
        className={classNames(s.navTextInner, {
          [s.navTextInnerAnimated]: shift > 0,
        })}
        style={{ '--sidebar-text-shift': `${shift}px` }}
      >
        {title}
      </span>
    </span>
  )
}

const MenuItem = ({ onClose, ...props }) => {
  const item = props.item
  const title = props.item?.title
  const url = getMenuItemUrl(item, props.userRole)
  const normalizedUrl = url?.split(/[?#]/)?.[0]?.replace(/\/+$/, '') || '/'
  const isManageNavigation = normalizedUrl === '/manage'
  const icon = props.menuIconCustomization?.icon || item.icon
  const iconStyle = getMenuIconStyle(props.menuIconCustomization)

  const isMobile = useScreenWidth(992)
  const [isCompactNavigationOpen, setIsCompactNavigationOpen] = useState(false)
  const isParentActive = useRoleActive('parent')
  const noticeCountTooltip = getMenuNoticeCountTooltip(item)
  const normalizedTitle = title?.toLocaleLowerCase?.('ru-RU') ?? ''
  const isUsersNavigation =
    ['/users/colleges', '/users/students'].includes(normalizedUrl) ||
    (normalizedTitle.includes('коллег') &&
      (normalizedTitle.includes('ученик') ||
        normalizedTitle.includes('учащ')))
  const isCompactNavigation = isUsersNavigation || isManageNavigation
  const closeCompactNavigation = () => {
    setIsCompactNavigationOpen(false)
    onClose?.()
  }

  if (!url) return null

  if (url.startsWith('http'))
    return (
      <Tooltip title={props.isMinimizedMenu ? title : ''} placement="right">
        <a
          href={url}
          onClick={(event) => {
            if (props.isEditing) {
              event.preventDefault()
              return
            }
            onClose?.()
          }}
          className={classNames(s.navLink, {
            [s.center]: props.isMinimizedMenu,
          })}
          target="_blank"
          rel="noreferrer"
          title={!props.isMinimizedMenu ? title : ''}
        >
          <GetIco
            icon={icon}
            style={iconStyle}
            className={classNames(s.navIco, {
              [s.navIcoMR]: !props.isMinimizedMenu,
            })}
          />
          <SidebarMarqueeText title={title} />
        </a>
      </Tooltip>
    )

  const navLink = (
    <NavLink
        exact={url === '/' && true}
        to={url}
        data-platform-training-target={
          isPlatformTrainingTarget(item, props.userRole)
            ? 'students-and-colleagues'
            : undefined
        }
        onMouseEnter={() => {
          if (!isMobile && !props.isEditing && isReportsNavigationUrl(url)) {
            openReportsNavigation()
          }
        }}
        onMouseLeave={() => {
          if (!isMobile && !props.isEditing && isReportsNavigationUrl(url)) {
            closeReportsNavigation()
          }
        }}
        onClick={(event) => {
          if (props.isEditing) {
            event.preventDefault()
            return
          }

          if (isReportsNavigationUrl(url)) {
            event.preventDefault()
            openReportsNavigation()
          }

          if (isManageNavigation || (isMobile && isUsersNavigation)) {
            event.preventDefault()
            if (isMobile) setIsCompactNavigationOpen((value) => !value)
            return
          }

          onClose?.()
        }}
        className={classNames(s.navLink, { [s.center]: props.isMinimizedMenu })}
        activeClassName={s.active}
        aria-expanded={isMobile && isCompactNavigation ? isCompactNavigationOpen : undefined}
        title={!props.isMinimizedMenu ? title : ''}
      >
        <GetIco
          icon={icon}
          style={iconStyle}
          className={classNames(s.navIco, {
            [s.navIcoMR]: !props.isMinimizedMenu,
          })}
        />{' '}
        <SidebarMarqueeText title={title} />
        {/*{item.has_notify && <Notify url={item.url} />}*/}
        <div className={s.noticeWrapper}>
          {item?.notice &&
            Array.isArray(item.notice) &&
            item.notice
              .filter((n) => n?.value !== null && n?.value !== undefined)
              .map((notice, index) => (
                <TooltipWrapper
                  title={
                    notice?.tooltip && !isMobile ? notice?.tooltip : undefined
                  }
                  key={index}
                  className={s.noticeTooltip}
                >
                  <span
                    className={cn('notice', s.notice)}
                    style={
                      notice?.color ? { backgroundColor: notice.color } : {}
                    }
                  >
                    {notice?.value}
                  </span>
                </TooltipWrapper>
              ))}
          {shouldShowMenuNoticeCount(item) && !props.isMinimizedMenu && (
            noticeCountTooltip && !isMobile ? (
              <TooltipWrapper
                title={noticeCountTooltip}
                className={s.noticeTooltip}
              >
                <span className={cn('notice', s.notice)}>{item.noticeCount}</span>
              </TooltipWrapper>
            ) : (
              <span className={cn('notice', s.notice)}>{item.noticeCount}</span>
            )
          )}
        </div>
    </NavLink>
  )
  const usersNavigation = (
    <nav className={s.usersNavigation} aria-label="Коллеги и учащиеся">
      <NavLink
        to="/users/colleges"
        activeClassName={s.usersNavigationLinkActive}
        onClick={closeCompactNavigation}
      >
        Коллеги
      </NavLink>
      <NavLink
        to="/users/students"
        activeClassName={s.usersNavigationLinkActive}
        onClick={closeCompactNavigation}
      >
        Учащиеся
      </NavLink>
      {isParentActive && (
        <NavLink
          to="/users/parents"
          activeClassName={s.usersNavigationLinkActive}
          onClick={closeCompactNavigation}
        >
          Родители
        </NavLink>
      )}
    </nav>
  )
  const manageNavigation = (
    <nav className={s.usersNavigation} aria-label="Ученики, группы и классы">
      <NavLink
        to="/manage/students"
        activeClassName={s.usersNavigationLinkActive}
        onClick={closeCompactNavigation}
      >
        Ученики
      </NavLink>
      <NavLink
        to="/manage/groups"
        activeClassName={s.usersNavigationLinkActive}
        onClick={closeCompactNavigation}
      >
        {props.groupNamePlural || 'Группы'}
      </NavLink>
      {MANAGE_CLASSES_ROLES.includes(getBaseRole(props.userRole)) && (
        <NavLink
          to="/manage/classes"
          activeClassName={s.usersNavigationLinkActive}
          onClick={closeCompactNavigation}
        >
          Классы
        </NavLink>
      )}
    </nav>
  )

  if (isMobile && isCompactNavigation && !props.isEditing) {
    return (
      <div className={s.mobileNavigationGroup}>
        {navLink}
        {isCompactNavigationOpen && (
          <div className={s.mobileSubmenu}>
            {isUsersNavigation ? usersNavigation : manageNavigation}
          </div>
        )}
      </div>
    )
  }

  return (
    <Tooltip
      title={props.isMinimizedMenu && !isCompactNavigation ? title : ''}
      placement="right"
    >
      {isCompactNavigation && !props.isEditing ? (
        <Popover
          content={isUsersNavigation ? usersNavigation : manageNavigation}
          trigger={isMobile ? 'click' : 'hover'}
          placement="rightTop"
          mouseEnterDelay={0}
          mouseLeaveDelay={0.12}
          overlayClassName={s.usersNavigationPopover}
          arrow={false}
        >
          {navLink}
        </Popover>
      ) : (
        navLink
      )}
    </Tooltip>
  )
}

export const NavigationApp = connect((state) => ({ menu: state.menu.items }), {
  fetchMenu,
})(({ menu, fetchMenu, onClose, isMinimizedMenuOverride }) => {
  const { groupNamePlural } = useGetGroupName()
  const isMinimizedMenuFromStore = useIsMinimizedMenu()
  const isMinimizedMenu = isMinimizedMenuOverride ?? isMinimizedMenuFromStore
  const profile = useSelector(selectProfile)
  const selectedLanguageId = useSelector(selectSelectedLanguageId)
  const parentSelectedChildId = useSelector((state) => state.parentSelectedChildId)
  const menuIconsSetting = useSelector(
    (state) => state.settings.custom?.[PLATFORM_MENU_ICONS_SETTING_KEY],
  )
  const menuIconCustomizations = useMemo(
    () => parsePlatformMenuIcons(menuIconsSetting),
    [menuIconsSetting],
  )
  const [isEditing, setIsEditing] = useState(false)
  const [orderedMenu, setOrderedMenu] = useState([])
  const [userMenuOrder, setUserMenuOrder] = useState([])
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 6 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  )

  useEffect(
    (_) => {
      fetchMenu()
    },
    [selectedLanguageId, parentSelectedChildId],
  )

  useEffect(() => {
    let isCurrent = true

    if (!profile?.id) {
      setUserMenuOrder([])
      return undefined
    }

    setUserMenuOrder([])
    menuApi.getUserOrder()
      .then(({ data }) => {
        if (isCurrent) setUserMenuOrder(Array.isArray(data) ? data : [])
      })
      .catch(() => {
        if (isCurrent) setUserMenuOrder([])
      })

    return () => {
      isCurrent = false
    }
  }, [profile?.id, profile?.role])

  useEffect(() => {
    if (!Array.isArray(menu)) {
      setOrderedMenu([])
      return
    }

    setOrderedMenu(applyUserMenuOrder(menu, userMenuOrder))
  }, [menu, userMenuOrder])

  useEffect(() => {
    if (isMinimizedMenu) setIsEditing(false)
  }, [isMinimizedMenu])

  const saveSidebarOrder = (nextMenu) => {
    const items = []
    nextMenu.forEach((group, position) => {
      if (group.folder) {
        items.push({
          element_type: 'folder',
          element_id: group.folder.id,
          parent_folder_id: null,
          position,
        })
      }

      group.items?.forEach((item, itemPosition) => {
        items.push({
          element_type: 'item',
          element_id: item.id,
          parent_folder_id: group.folder?.id ?? null,
          position: group.folder ? itemPosition : position,
        })
      })
    })

    setUserMenuOrder(items)
    menuApi.saveUserOrder(items).catch(() => {})
  }

  const handleSidebarDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return

    if (String(active.id).startsWith(MENU_ITEM_DRAG_PREFIX)) {
      let hasChanges = false
      const nextMenu = orderedMenu.map((group) => {
        const oldIndex = group.items?.findIndex((item) => getMenuItemDragKey(item) === active.id) ?? -1
        const newIndex = group.items?.findIndex((item) => getMenuItemDragKey(item) === over.id) ?? -1

        if (oldIndex < 0 || newIndex < 0) return group

        hasChanges = true
        return { ...group, items: arrayMove(group.items, oldIndex, newIndex) }
      })

      if (hasChanges) {
        setOrderedMenu(nextMenu)
        saveSidebarOrder(nextMenu)
      }
      return
    }

    const oldIndex = orderedMenu.findIndex((group, index) => getMenuGroupKey(group, index) === active.id)
    const newIndex = orderedMenu.findIndex((group, index) => getMenuGroupKey(group, index) === over.id)
    if (oldIndex < 0 || newIndex < 0) return

    const nextMenu = arrayMove(orderedMenu, oldIndex, newIndex)
    setOrderedMenu(nextMenu)
    saveSidebarOrder(nextMenu)
  }

  return (
    <>
      {!isMinimizedMenu && (
        <button
          type="button"
          className={classNames(s.menuOrderButton, { [s.menuOrderButtonActive]: isEditing })}
          onClick={() => setIsEditing((value) => !value)}
        >
          {isEditing ? <CheckOutlined /> : <SettingOutlined />}
          {isEditing ? 'Готово' : 'Настроить меню'}
        </button>
      )}
      {isEditing && !isMinimizedMenu && (
        <div className={s.menuOrderHint}>Перетащите разделы и пункты в нужном порядке</div>
      )}
      <DndContext sensors={sensors} collisionDetection={sidebarCollisionDetection} onDragEnd={handleSidebarDragEnd}>
        <SortableContext
          items={orderedMenu.map(getMenuGroupKey)}
          strategy={verticalListSortingStrategy}
        >
          <nav className={cn(s.navList, 'list-reset', { [s.navListEditing]: isEditing })}>
            {orderedMenu.map((menuItem, i) => {
              const groupKey = getMenuGroupKey(menuItem, i)
              return (
                <SortableMenuGroup
                  key={groupKey}
                  id={groupKey}
                  disabled={!isEditing}
                  showHandle={isEditing}
                >
                  <FolderItem
                    folder={menuItem.folder}
                    menuIconCustomization={
                      menuIconCustomizations.basic[
                        getMenuCustomizationKey(menuItem.folder, 'folder')
                      ]
                    }
                    isMinimizedMenu={isMinimizedMenu}
                    index={i}
                    isEditing={isEditing}
                    containsPlatformTrainingTarget={menuItem.items?.some((item) => (
                      isPlatformTrainingTarget(item, profile?.role)
                    ))}
                  >
                    <SortableContext
                      items={menuItem.items?.map(getMenuItemDragKey) ?? []}
                      strategy={verticalListSortingStrategy}
                    >
                      {menuItem.items?.map((item) => (
                        <SortableMenuItem
                          key={item.id}
                          id={getMenuItemDragKey(item)}
                          disabled={!isEditing || !menuItem.folder}
                        >
                          <MenuItem
                            item={item}
                            menuIconCustomization={
                              menuIconCustomizations.basic[
                                getMenuCustomizationKey(item)
                              ]
                            }
                            onClose={isEditing ? undefined : onClose}
                            isMinimizedMenu={isMinimizedMenu}
                            isEditing={isEditing}
                            userRole={profile?.role}
                            groupNamePlural={groupNamePlural}
                          />
                        </SortableMenuItem>
                      ))}
                    </SortableContext>
                  </FolderItem>
                </SortableMenuGroup>
              )
            })}
          </nav>
        </SortableContext>
      </DndContext>
    </>
  )
})

const SortableMenuGroup = ({ id, disabled, showHandle, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id, disabled })
  return (
    <div
      ref={setNodeRef}
      className={classNames(s.sortableGroup, {
        [s.sortableGroupEditing]: showHandle,
        [s.sortingItem]: isDragging,
      })}
      style={{
        transform: CSS.Transform.toString(transform),
        transition: isDragging ? 'none' : transition,
      }}
    >
      {showHandle && <DragOutlined className={s.groupDragHandle} {...attributes} {...listeners} />}
      {children}
    </div>
  )
}

const SortableMenuItem = ({ id, disabled, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id, disabled })
  const dragProps = disabled ? {} : { ...attributes, ...listeners }

  return (
    <div
      ref={setNodeRef}
      className={classNames(s.sortableMenuItem, {
        [s.sortableMenuItemEditing]: !disabled,
        [s.sortingItem]: isDragging,
      })}
      style={{
        transform: CSS.Transform.toString(transform),
        transition: isDragging ? 'none' : transition,
      }}
      {...dragProps}
    >
      {!disabled && <DragOutlined className={s.itemDragHandle} />}
      {children}
    </div>
  )
}

const FolderItem = ({
  folder,
  menuIconCustomization,
  isMinimizedMenu,
  children,
  index,
  isEditing = false,
  containsPlatformTrainingTarget = false,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  if (!folder) return <>{children}</>
  if (Number(folder.is_active) === 0) return <></>

  const title = folder?.title

  return (
    <div className={s.folder}>
      <Tooltip title={isMinimizedMenu ? title : ''} placement="right">
        <div
          className={classNames(s.folderNavLink, s.navLink, {
            [s.center]: isMinimizedMenu,
          })}
        >
          <div className={s.folder_block}>
            <div
              className={s.folderTitle}
              data-platform-training-folder-target={
                containsPlatformTrainingTarget ? 'students-and-colleagues' : undefined
              }
              data-platform-training-folder-open={isOpen ? 'true' : 'false'}
              style={{
                background:
                  backgraundColorList[index % backgraundColorList.length],
              }}
              onClick={() => !isEditing && setIsOpen(!isOpen)}
            >
              <GetIco
                icon={menuIconCustomization?.icon || 'folder'}
                style={getMenuIconStyle(menuIconCustomization)}
                className={classNames(s.navIco, {
                  [s.navIcoMR]: !isMinimizedMenu,
                })}
              />
              <SidebarMarqueeText title={title} />
              <GetIco
                icon={isOpen ? 'angle_arrow_down' : 'angle_arrow_up'}
                className={classNames(s.arrow, { [s.arrow2]: true })}
              />
            </div>
            <div
              className={classNames(s.folderChildren, {
                [s.folderChildrenOpen]: isOpen || isEditing,
              })}
            >
              {children}
            </div>
          </div>
        </div>
      </Tooltip>
    </div>
  )
}

const Notify = ({ url }) => {
  let count = 0
  const profile = useSelector(selectProfile)
  const unverifiedHWCount = useSelector(selectorTotalCountUHW)
  if (
    url === '/dz-students' &&
    getBaseRole(profile?.role) === 'seminarian' &&
    unverifiedHWCount > 0
  ) count = unverifiedHWCount

  const ownBacklogCount = useSelector(selectorOwnBacklogCount)
  if (url === '/home-work' && ownBacklogCount > 0) count += ownBacklogCount

  if (count === 0) return <></>
  return <span className={cn('notice', s.notice)}>{count}</span>
}

function showUserCustomId(profile) {
  let customId = profile?.custom_id

  return customId && <span className={s.customId}>{customId}</span>
}
